<template>
  <div class="col-auto btn-edit">
    <q-btn-dropdown
      data-testid="contato-editar-nome"
      v-model="menu"
      flat
      dense
      size="xs"
      no-icon-animation
      :disable="isDisabled"
      dropdown-icon="none"
    >
      <template #label>
        <EditIcon
          class="edit-icon"
          clickable
        />
        <q-tooltip>Editar nome do cliente</q-tooltip>
      </template>

      <div
        class="row no-wrap q-pa-sm"
        style="min-width: 300px"
      >
        <div class="column full-width">
          <div class="row justify-center">
            <div class="col-auto">
              <q-icon
                name="mdi-square-edit-outline"
                size="xs"
                color="primary"
              />
              <span style="font-size: 16px; padding-left: 10px;">Alterar Nome</span>
            </div>
          </div>
          <div class="col-auto text-center text-caption text-grey-8">
            {{ labelContact }}
          </div>
          <div class="text-h6 q-mt-xs">
            <FieldText
              data-testid="contato-nome"
              type="text"
              label="Nome a ser exibido no chat"
              v-model="clientName"
              :error-message="messageError"
              :is-valid="isValid"
            />
          </div>
        </div>
      </div>
      <q-separator />

      <div class="row full-width justify-between q-pa-xs">
        <q-btn
          data-testid="contato-cancelar"
          color="primary"
          label="Cancelar"
          flat
          no-caps
          v-close-popup
        />
        <q-btn
          data-testid="contato-alterar"
          color="primary"
          label="Alterar"
          flat
          no-caps
          :disable="handleDisable"
          @click="handleChangeName"
        />
      </div>
      <q-dialog
        v-model="showDialogConfirm"
        persistent
      >
        <q-card
          flat
          bordered
        >
          <div class="row full-width justify-end q-pa-sm">
            <q-btn
              data-testid="contato-confirmacao-fechar"
              size="xs"
              flat
              round
              dense
              icon="mdi-close"
              v-close-popup
            />
          </div>

          <q-card-section class="items-center">
            <div class="row full-width justify-center">
              <AlertIcon
                class="alert-icon"
              />
            </div>
            <div class="span-text">
              <span>Tem certeza que deseja alterar o nome do cliente?</span>
              <p class="irreversible-action-warning">
                Esta ação não poderá ser desfeita.
              </p>
            </div>
          </q-card-section>

          <q-separator />

          <q-card-actions align="around">
            <q-btn
              data-testid="contato-confirmacao-cancelar"
              flat
              no-caps
              padding="5px 12px"
              color="primary"
              v-close-popup
            >
              Cancelar
            </q-btn>

            <q-btn
              data-testid="contato-confirmacao-confirmar"
              no-caps
              padding="5px 12px"
              color="primary"
              @click="onOKClick"
            >
              Confirmar
            </q-btn>
          </q-card-actions>

          <q-inner-loading
            :showing="loading"
          />
        </q-card>
      </q-dialog>
    </q-btn-dropdown>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FieldText from '@/components/fields/FieldText'
import EditIcon from '@/assets/icons/edit.svg'
import AlertIcon from '@/assets/icons/alert.svg'
import api from '@/libs/api'
import { anonymizePhone } from '@/components/utils/phones'
import { getContactNumber } from '@/libs/helpers'

export default {
  components: {
    EditIcon,
    AlertIcon,
    FieldText
  },

  props: {
    attendance: {},
    channel: {}
  },

  data () {
    return {
      menu: false,
      loading: false,
      clientName: '',
      showDialogConfirm: false
    }
  },

  computed: {
    ...mapGetters({
      queueProperties: 'agentModule/queueProperties'
    }),

    labelContact () {
      if (this.channel === 'TEXT') {
        const contact = getContactNumber(this.attendance)
        const phone = this.isAnonymizationEnabled ? anonymizePhone(contact) : contact
        return `${phone} - ${this.attendance.contact}`
      }

      if (this.channel === 'VOICE') return this.attendance.contact
      return ''
    },

    handleDisable () {
      return !this.clientName || !this.isValid
    },

    isDisabled () {
      return this.attendance.status === 'OFFERING'
    },
    hasIcon () {
      return this.clientName.match(/(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu)
    },
    isValid () {
      return !this.hasIcon && (!this.clientName || this.clientName.length <= 30)
    },

    messageError () {
      if (this.hasIcon) return 'Nome não pode conter emojis'
      return 'Nome não pode ultrapassar 30 caracteres'
    },

    queueId () {
      return this.attendance?.queueId ?? this.attendance?.queue
    },

    isAnonymizationEnabled () {
      if (this.attendance?.shouldAnonymize) return true
      if (!this.queueId) return false
      const queueProps = this.queueProperties(this.queueId)
      return queueProps?.anonymizePhone === 'yes'
    }
  },

  methods: {
    ...mapActions({
      updateContact: 'attendanceModule/updateContact'
    }),
    handleChangeName () {
      this.showDialogConfirm = true
    },

    async onOKClick  () {
      this.loading = true
      const payload = {
        chatId: this.attendance.id,
        queueId: this.attendance.queueId,
        sourceId: this.attendance.sourceId,
        nickName: this.clientName
      }

      try {
        await api.putChatsInfo(payload)

        this.updateContact({ attendance: this.attendance, contact: this.clientName })

        this.$q.notify({
          message: 'Nome do cliente alterado com sucesso',
          color: 'positive',
          position: 'center'
        })
      } catch (error) {
        this.$q.notify({
          message: 'Erro ao alterar nome do cliente',
          color: 'negative',
          position: 'center'
        })
      } finally {
        this.menu = false
        this.showDialogConfirm = false
        this.loading = false
        this.clientName = ''
      }
    }

  }
}

</script>
<style lang="sass">
  .edit-icon
    height: 14px
    width: 14px
    cursor: pointer

  .alert-icon
    height: 50px
    width: 50px
    fill: #ffca28

  .btn-edit
    .q-btn-dropdown__arrow
      display: none

  .span-text
    padding: 10px
    font-size: 16px
    text-align: center
    font-weight: 400

    .irreversible-action-warning
      margin-top: 10px
      font-size: 14px
      text-align: center
      color: #616161
</style>
